export const DietMealPlanReviewTableColumns = [
  {
    id: "S.No",
    label: "S.No",
    minWidth: 70,
    align: "left",
  },
  {
    id: "patientName",
    label: "Patient Name",
    minWidth: 200,
    align: "left",
  },
  {
    id: "dietType",
    label: "Plan Type",
    minWidth: 150,
    align: "center",
  },
  {
    id: "currentWeek",
    label: "Current Week",
    minWidth: 120,
    align: "center",
  },
  {
    id: "dueDate",
    label: "Due Date",
    minWidth: 120,
    align: "center",
  },
  {
    id: "approvalWindow",
    label: "Status",
    minWidth: 150,
    align: "center",
  },
  {
    id: "action",
    label: "Actions",
    minWidth: 120,
    align: "center",
  },
];


